/**
 * External dependencies
 */
// import { OrderSummary } from '@woocommerce/base-components/cart-checkout';
// import { useStoreCart } from '@woocommerce/base-context/hooks';
// import { TotalsWrapper } from '@woocommerce/blocks-components';


// import OrderSummary from '../wc_components/js/base/components/cart-checkout/order-summary';

import { OrderSummary } from '../wc_components/js/base/components';

// import TotalsWrapper from '../wc_components/packages/components/totals-wrapper';
import { TotalsWrapper } from '../wc_components/packages/components';
import { useStoreCart } from '../wc_components/js/base/context';

// import { TotalsWrapper } from '../wc_components/components';
import React from 'react';
// import { Panel } from '../../../../../packages/components';
// import { Panel } from '../wc_components/packages/components';
// import { __ } from '@wordpress/i18n';

// import { ContainerWidthContextProvider } from '../wc_components/js/base/context';
// import classNames from 'classnames';

const Block = ( { className }: { className: string } ): JSX.Element => {
	// const { cartItems } = useStoreCart();

	// return (
	// 	<div className={ className }>
	// 		SAI
	// 	</div>
	// );


	const { cartItems } = useStoreCart();

	
	return (
		<TotalsWrapper className={ className }>
			{/* <ContainerWidthContextProvider
				className={ classNames(
					'wc-block-components-sidebar-layout',
					className
				) }
			>
				<OrderSummary cartItems={ cartItems } />
			</ContainerWidthContextProvider>	 */}
			<OrderSummary cartItems={ cartItems } />
		</TotalsWrapper>
	);
};

export default Block;
